module.exports = __webpack_public_path__ + "static/media/naiftytlogo.9ca6a481.png";